import { MacroListingModel, IMacroListingModel, IOrderByParams } from '@common/models';
import { MacroTargetType, MacroType } from '@common/models/Enums/MacroType';
import { SearchService } from '@common/services/searchService';
import { StandardSearchStore } from '@common/stores';
import { IQueryCacheStoreInit } from '@common/stores/QueryCacheStore';
import { makeObservable } from "mobx";


export interface ICommunicationTemplateFilter {
    name?: string
    macroTypeId?: number
    hospitalId?: number
    userId?: number
    userName?: string
    isActive?: boolean
    createdBy?: string
    lastModifiedBy?: string
    macroScope?: MacroType,
    macroTargetTypeId?: MacroTargetType
}

const defaultCommunicationTemplateSortOrder = (macroScope?: MacroType): IOrderByParams[] =>
    macroScope == MacroType.Provider
        ? [{ field: "name", dir: "asc" }]
        : [{ field: "datecreated", dir: "desc" }]

export class CommunicationTemplateSearchStore extends StandardSearchStore<ICommunicationTemplateFilter, IMacroListingModel, MacroListingModel> {
    constructor(macroScope?: MacroType, hospitalId?: number, userId?: number, top: number = 10, macroTargetTypeId?: MacroTargetType, queryClient?: IQueryCacheStoreInit) {
        super({
            endpointUrl: SearchService.SearchEndPoints.macros,
            defaultSearchParams: {
                orderby: defaultCommunicationTemplateSortOrder(macroScope), top: top
            },
            defaultSearchFilter: {
                macroScope: macroScope, hospitalId: hospitalId, userId: userId, macroTargetTypeId: macroTargetTypeId
            }            
        }, (result: IMacroListingModel) => new MacroListingModel(result),queryClient)
        makeObservable(this, undefined);
    }
}
